import { useMemo } from "react";

import { useLocalization } from "@i18n";
import { LoadingBlurDiv } from "@shared/components";

import { useLicenseInventoryUrlQuery } from "../api/license-inventory";
import { AdminLicenseInventoryTab } from "../components/organisms";
import type { AdminLicenseInventoryFilterData } from "../schemas";

const AdminLicenseInventoryPage = () => {
  const { translate } = useLocalization();
  const { query, setFilters, resetFilters, currentFilters } =
    useLicenseInventoryUrlQuery();

  // `currentFilters.onlyActive` chega como string ("true"/"false") porque vem
  // do URL search param. O backend aceita ambos (Transform na validation),
  // mas o form precisa de boolean para o Checkbox renderizar corretamente.
  const initialFilters = useMemo<Partial<AdminLicenseInventoryFilterData>>(
    () => ({
      complex: currentFilters.complex,
      structure: currentFilters.structure,
      module: currentFilters.module,
      onlyActive:
        typeof currentFilters.onlyActive === "string"
          ? currentFilters.onlyActive === "true"
          : Boolean(currentFilters.onlyActive),
    }),
    [currentFilters],
  );

  return (
    <div className="flex flex-col gap-4">
      <header className="flex flex-col gap-1">
        <h1 className="text-xl font-semibold">
          {translate("admin.licenseInventory.page.title")}
        </h1>
        <p className="text-sm text-muted-foreground">
          {translate("admin.licenseInventory.page.subtitle")}
        </p>
      </header>

      <LoadingBlurDiv isLoading={query.isFetching}>
        <AdminLicenseInventoryTab
          items={query.data?.data ?? []}
          paginatedMeta={query.data?.meta}
          isLoading={query.isFetching}
          onFilter={setFilters}
          onClearFilter={resetFilters}
          initialFilters={initialFilters}
        />
      </LoadingBlurDiv>
    </div>
  );
};

export default AdminLicenseInventoryPage;
